<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 p-1 ">
      <h2 class="mb-0 main-title"> Manage Locations</h2>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-md btn-primary fs-11 fw-normal hover-white" @click="openCreateModal('createModal')">
          <i class="fa fa-plus fs-11"></i> Add New Location
        </button>
      </div>
    </div>
    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger hover-white">
        <span class="material-symbols-outlined fs-6">undo</span> Reset
      </button>
    </div>
    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>
    <div class="card p-1 bg-white">
      <FormModal ref="createModal" title="Create New Location" id="create_location_form_modal">
        <CreateLocation :Parentlocations="Parentlocations" ref="createLocationForm" @created="onLocationCreated"
          @close="closeCreateModal('createModal')" />
      </FormModal>

      <FormModal ref="editModal" title="Edit Location" id="edit_location_form_modal">
        <EditLocation v-if="selectedLocation" :location="selectedLocation" :Parentlocations="Parentlocations"
          @updated="onLocationUpdated" @close="closeEditModal" />
      </FormModal>

      <LoadingBar v-if="loading" message="Loading Locations..." />
      <div v-else class="table-wrapper">
        <ListTable>

          <colgroup>
            <!-- <col style="width: 6%">  -->
            <col style="width: 32%"> <!-- Name -->
            <col style="width: 17%"> <!-- Code -->
            <col style="width: 26%"> <!-- Description -->
            <col style="width: 15%"> <!-- Created On -->
            <col style="width: 10%"> <!-- Action -->
          </colgroup>

          <thead>
            <tr>
              <!-- <th>SR#</th> -->

              <th @click="sortBy('name')" class="sortable">
                Name <i :class="getSortIcon('name')"></i>
              </th>

              <th @click="sortBy('code')" class="sortable">
                Code <i :class="getSortIcon('code')"></i>
              </th>

              <th @click="sortBy('description')" class="sortable">
                Description <i :class="getSortIcon('description')"></i>
              </th>

              <th @click="sortBy('created_at')" class="sortable">
                Created On <i :class="getSortIcon('created_at')"></i>
              </th>

              <th class="text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="location in sortedData" :key="location.external_id">
             <!-- <td>
                  {{ index + 1 }}
              </td> -->

              <td class="align-middle">
                <div class="d-flex align-items-center gap-2">
                  <div
                    class="d-flex align-items-center justify-content-center bg-primary-subtle border border-primary-subtle rounded-3"
                    style="width: 30px; height: 30px; min-width: 30px;">
                    <span class="material-symbols-outlined text-primary fs-10">location_on</span>
                  </div>
                  <span class="text-dark">{{ location.name }}</span>
                </div>
              </td>

              <td>{{ location.code }}</td>
              <td>{{ location.description }}</td>
              <td>{{ location.created_at }}</td>

              <td class="text-center">
                <TableActionDropdown>
                  <li>
                    <a class="dropdown-item" @click.prevent="viewDetails(location)">
                      <i class="fa fa-eye text-info"></i>
                      <span>Profile</span>
                    </a>
                  </li>

                  <li>
                    <a class="dropdown-item" @click.prevent="editLocation(location)">
                      <i class="fa fa-pencil text-primary"></i>
                      <span>Edit</span>
                    </a>
                  </li>
                    <hr class="dropdown-divider" />
                  <li>
                    <a class="dropdown-item item-danger" @click.prevent="deleteAsset(location)">
                      <i class="fa fa-trash"></i>
                      <span>Delete</span>
                    </a>
                  </li>
                </TableActionDropdown>
              </td>
            </tr>

            <tr v-if="sortedData.length === 0">
              <td colspan="6" class="text-center">No locations found</td>
            </tr>
          </tbody>

        </ListTable>
      </div>

      <!-- Pagination -->
      <Pagination :pagination="pagination" @page-change="changePage" />
    </div>
  </div>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateLocation from '@/views/Location/CreateLocation.vue'
import ListTable from '@/components/utils/ListTable.vue'
import TableActionDropdown from '@/components/TableActionDropdown.vue'
import EditLocation from '@/views/Location/EditLocation.vue'

export default {
  name: 'LocationList',
  components: {
    Pagination,
    LoadingBar,
    FormModal,
    CreateLocation,
    ListTable,
    TableActionDropdown,
    EditLocation,
  },
  data() {
    return {
      locations: [],
      Parentlocations: [],
      selectedLocation: null,
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false,
      editLoading: false,
      filterManager: null,
      sortColumn: null,
      sortOrder: 'asc',
      filteredData: [],
      currentFilters: {},
    }
  },
  computed: {
    sortedData() {
      let result = [...this.filteredData];

      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];

          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';

          if (this.sortColumn === 'id') {
            valA = parseInt(String(valA).replace('#', '')) || 0;
            valB = parseInt(String(valB).replace('#', '')) || 0;
          }

          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },
    filteredParentLocations() {
      if (!this.selectedLocation || !this.selectedLocation.id) {
        return this.Parentlocations;
      }
      return this.Parentlocations.filter(
        loc => loc.id !== this.selectedLocation.id
      );
    }
  },
  mounted() {
    this.fetchParentLocations()
    this.fetchLocations()
  },
  methods: {
    openCreateModal(ref) {
      this.$refs[ref].showModal()
    },

    closeCreateModal(ref) {
      this.$refs[ref].closeModal()
    },

    async onLocationCreated() {
      this.pagination.current_page = 1
      await this.fetchLocations()
      await this.fetchParentLocations()
    },

    async fetchLocations() {
      this.loading = true

      const result = await form_api_submit({
        url: 'locations/list',
        method: 'GET',
        data: {
          page: this.pagination.current_page,
          ...this.currentFilters
        },
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        this.locations = result.data.list
        this.filteredData = [...result.data.list]
        this.pagination = result.data.pagination
      }

      this.loading = false
    },

    async fetchParentLocations() {
      this.loading = true

      const result = await form_api_submit({
        url: 'locations/get-locations',
        method: 'GET',
        data: {},
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        this.Parentlocations = result.data
        this.initFilters();
      }

      this.loading = false
    },

    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      this.fetchLocations()
    },

    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      const parentOptions = (this.Parentlocations || []).map(loc => ({
        value: String(loc.id),
        label: loc.name
      }));

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          { key: "id", label: "ID", type: "input", placeholder: "Filter by ID" },
          { key: "name", label: "Name", type: "input", placeholder: "Filter by Name" },
          { key: "parent_location", label: "Parent Location", type: "checkbox", options: parentOptions }
        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },

    applyFilters(activeFilters) {
      this.currentFilters = { ...activeFilters };
      this.pagination.current_page = 1;
      this.fetchLocations();
    },

    resetPagination() {
      this.pagination.current_page = 1;
      this.fetchLocations();
    },

    // Fetch full location detail (with attachments) before opening the edit modal
    async editLocation(location) {
      if (this.editLoading) return
      this.editLoading = true

      const locationId = location.id || location.external_id

      const result = await form_api_submit({
        url: `locations/edit/${locationId}`,
        method: 'GET',
        show_success_toast: false,
        show_error_toast: true
      })

      this.editLoading = false

      if (result.success) {
        this.selectedLocation = result.data

        this.$nextTick(() => {
          this.$refs.editModal.showModal()
        })
      }
    },

    closeEditModal() {
      this.$refs.editModal.closeModal()
      this.selectedLocation = null
    },

    async onLocationUpdated() {
      this.closeEditModal()
      await this.fetchLocations()
      await this.fetchParentLocations()
    },

    viewDetails(location) {
      // TODO: wire to a real details view/endpoint when ready
      console.log('View details for', location)
    },

    deleteAsset(location) {
      // TODO: wire to a real delete endpoint when ready
      console.log('Delete location', location)
    },

    resetAllFilters() {
      this.currentFilters = {};
      this.pagination.current_page = 1;
      this.sortColumn = null;
      this.sortOrder = 'asc';
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      } else {
        this.fetchLocations();
      }
    },

    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
      this.resetPagination();
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },
  }
}
</script>

<style scoped>
.page-link {
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #667eea;
  border-color: #667eea;
}

img {
  object-fit: cover;
}
</style>